import React, { useState, useEffect } from 'react';
import { Button } from '../../../../../components/ui/button';
import {
    AlertDialog,
    AlertDialogCancel,
    AlertDialogContent,
    AlertDialogDescription,
    AlertDialogFooter,
    AlertDialogHeader,
    AlertDialogTitle
} from '../../../../../components/ui/alert-dialog';
import { Input } from '../../../../../components/ui/input';
import { useSelector } from 'react-redux';

const RejectAddFields = ({
    open,
    descriptionText,
    actionText,
    rejectRemarks,
    setRejectRemarks,
    handleClose,
    confirmAction
}) => {
    const { remarks } = useSelector((state) => state.Uploads.errors);

    // Add local state for debounced input
    const [debouncedRejectRemarks, setDebouncedRejectRemarks] = useState(rejectRemarks);

    useEffect(() => {
        const timer = setTimeout(() => {
            setRejectRemarks(debouncedRejectRemarks);
        }, 500); // 500ms debounce delay

        // Clean up the timeout on every change or component unmount
        return () => clearTimeout(timer);
    }, [debouncedRejectRemarks, setRejectRemarks]);

    return (
        <AlertDialog open={open} onDismiss={handleClose}>
            <AlertDialogContent>
                <AlertDialogHeader>
                    <AlertDialogTitle>Reject Additional Fields</AlertDialogTitle>
                </AlertDialogHeader>
                <AlertDialogDescription className="hidden" />
                <div className="text-sm text-normal">
                    Are you sure do not you want to add the fields to the database?
                    <section className='mt-3'>
                        <p className='mb-2'>Remarks *</p>
                        <Input
                            className="w-full bg-white opacity-1"
                            placeholder="Remarks"
                            value={debouncedRejectRemarks} // Use the debounced state here
                            onChange={(e) => setDebouncedRejectRemarks(e.target.value)} // Set the debounced value on input change
                        />
                        <small className="text-destructive text-xs mt-1">{remarks || ""}</small>
                    </section>
                </div>
                {/* <div>
                    Are you sure do not you want to add the fields to the database?
                    <div className='mt-3'>
                        <p className='mb-2'>Remarks *</p>
                        <Input className="w-full bg-white opacity-1" placeholder="Remarks" />
                    </div>
                </div> */}
                <AlertDialogFooter>
                    <AlertDialogCancel onClick={handleClose}>Cancel</AlertDialogCancel>
                    <Button type="button" onClick={confirmAction}>Reject</Button>
                </AlertDialogFooter>
            </AlertDialogContent>
        </AlertDialog>
    );
}

export default RejectAddFields;
